import React, { useState, useEffect } from "react";
import { Tooltip } from 'react-tooltip';
import { faChevronDown, faChevronUp } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import 'react-tooltip/dist/react-tooltip.css';
import "../../../css/components/OrderInfo/OrderSheet/OrderSheet.css"

import { GenericModal, ImageModal, Message } from "../../../components";
import { CreateOrder, EditOrderModal, UploadOrderImageModal } from "../../OrderInfo";
import { SearchArea } from "./SearchArea";
import { delay, exportData, formatTaiwanDate } from "../../../utils";
import { DataTable } from "../../DataTable";
import { OrderDataColums } from "../../../constants";
import { StatusWindow } from "../DeliveryStatus/StatusWindow";

import { getOrders, createOrder, updateOrder, uploadOrderImage } from "../../../service/api/Order/apiOrder";
import { getOptimizeRoute } from "../../../service/api/OptimizeRoute/apiOPR";

const OrderSheet = ({ data, count = 0 }) => {
    const urlParams = new URLSearchParams(window.location.search);
    const REACT_APP_API_URL = process.env.REACT_APP_API_URL || window.APP_CONFIG.REACT_APP_API_URL;
    
    // 提取 URL 參數值
    const urlReview = urlParams.get("review");
    const urlStatus = urlParams.get("status");
    const urlId = urlParams.get("id");
    const urlStart = urlParams.get("start");
    const urlEnd = urlParams.get("end");

    useEffect(() => {
        if (data) {
            setOrdersData(data);
            setOrderCount(count);
        }
    }, [data, count]);
    console.log(REACT_APP_API_URL);

    useEffect(() => {
        const loadOrdersWithDelay = async () => {
            Message('自動搜尋中...', 'info');
            await delay(1);
            let updatedSearchForm = { ...searchForm };

            updatedSearchForm = { ...updatedSearchForm, isShipped: urlStatus === 'notShipped' ? 0 : '' };
            updatedSearchForm = { ...updatedSearchForm, status: urlReview === 'unReviewed' ? 0 : urlReview === 'approved' ? 1 : '' };
            updatedSearchForm = { ...updatedSearchForm, ordersId: urlId || '' };
            updatedSearchForm = { ...updatedSearchForm, deliveryDateStart: urlStart || '' };
            updatedSearchForm = { ...updatedSearchForm, deliveryDateEnd: urlEnd || '' };

            setSearchForm(updatedSearchForm);
            await handleSearch({ page: 1, limit: 10, customParams: updatedSearchForm });
        };
        if (urlReview || urlStatus || urlId || (urlStart && urlEnd))
            loadOrdersWithDelay();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [urlReview, urlStatus, urlId, urlStart, urlEnd]);


    const [isCreateOpen, setIsCreateOpen] = useState(false); //開創建訂單視窗用
    const [imageModal, setImageModal] = useState({ open: false, src: "" }); //放圖片視窗資料用
    const [ordersData, setOrdersData] = useState([]); // 放原始訂單資料用
    const [orderCount, setOrderCount] = useState(0); // 放訂單總數用
    const [editOrder, setEditOrder] = useState(null); // 放當前編輯訂單的資料用
    const [orderDeliveryStatus, setOrderDeliveryStatus] = useState(null); // 放當前查看訂單狀態的資料用
    const [editImage, setEditImage] = useState(null); // 放當前編輯圖片的資料用
    const [showColumnSelector, setShowColumnSelector] = useState(false); // 篩選區域顯示開關
    const [showSearchArea, setShowSearchArea] = useState(false); // 搜尋區域顯示開關
    const [selectedRows, setSelectedRows] = useState([]); // 儲存勾選的訂單 id
    const [loading, setLoading] = useState(false); // BT loading開關

    const closeImage = () => setImageModal({ open: false, src: "" }); // 關閉圖片視窗用

    // 搜尋條件物件
    const [searchForm, setSearchForm] = useState({
        id: '',
        name: '',
        phone: '',
        email: '',
        deliverName: '',
        addressCity: '',
        deliveryDateStart: '',
        deliveryDateEnd: '',
        ids: '',
        isShipped: '',
        status: '',
    });

    // API 搜尋條件物件
    const searchFields = {
        id: searchForm.id,
        name: searchForm.name,
        phone: searchForm.phone,
        email: searchForm.email,
        deliverName: searchForm.deliverName,
        addressCity: searchForm.addressCity,
        deliveryDateStart: searchForm.deliveryDateStart,
        deliveryDateEnd: searchForm.deliveryDateEnd,
        isShipped: searchForm.isShipped,
        status: searchForm.status,
    };

    // Datable columes 與 data
    const allColumns = [
        {
            name: "選擇(未開啟為全選)", cell: row => (
                <label className="small-btn">
                    <input
                        type="checkbox"
                        checked={selectedRows.includes(row.id)} // 手動勾選才生效
                        onChange={e => {
                            if (!selectedRows.includes(row.id)) {
                                setSelectedRows(prev => [...prev, row.id]);
                            } else {
                                setSelectedRows(prev => prev.filter(id => id !== row.id));
                            }
                        }}
                    />
                </label>
            ), key: "check"
        },
        {
            name: "家具圖片",
            selector: row => {
                if (!row.furnitureImagePath || row.furnitureImagePath.length === 0) {
                    return <div className="thumb placeholder">無圖片</div>;
                }

                const maxShow = 2;
                const visibleImages = row.furnitureImagePath.slice(0, maxShow);
                const hiddenCount = row.furnitureImagePath.length - maxShow;

                return (
                    <div className="furniture-thumbs">
                        {visibleImages.map((imgPath, i) => (
                            <div
                                key={i}
                                className="thumb-wrapper"
                                // onClick={() => openImage(imgPath)}
                                onClick={() =>
                                    setImageModal({
                                        open: true,
                                        src: null,
                                        gallery: row.furnitureImagePath.map(
                                            p => `${REACT_APP_API_URL}/public${p}`
                                        ),
                                    })
                                }
                            >
                                <img
                                    src={`${REACT_APP_API_URL}/public${imgPath}`}
                                    alt={`家具 ${i + 1}`}
                                    className="thumb"
                                />
                                {i === visibleImages.length - 1 && hiddenCount > 0 && (
                                    <div className="thumb-overlay">+{hiddenCount}</div>
                                )}
                            </div>
                        ))}
                    </div>
                );
            }, key: "furnitureimage"
        },
        {
            name: "配送圖片", selector: row => {
                if (!row.imagePath || row.imagePath.length === 0) {
                    return <div className="thumb placeholder">無圖片</div>;
                }

                const maxShow = 2;
                const visibleImages = row.imagePath.slice(0, maxShow);
                const hiddenCount = row.imagePath.length - maxShow;

                return (
                    <div className="furniture-thumbs">
                        {visibleImages.map((imgPath, i) => (
                            <div
                                key={i}
                                className="thumb-wrapper"
                                // onClick={() => openImage(imgPath)}
                                onClick={() =>
                                    setImageModal({
                                        open: true,
                                        src: null,
                                        gallery: row.imagePath.map(
                                            p => `${REACT_APP_API_URL}/public${p}`
                                        ),
                                    })
                                }
                            >
                                <img
                                    src={`${REACT_APP_API_URL}/public${imgPath}`}
                                    alt={`家具 ${i + 1}`}
                                    className="thumb"
                                />
                                {i === visibleImages.length - 1 && hiddenCount > 0 && (
                                    <div className="thumb-overlay">+{hiddenCount}</div>
                                )}
                            </div>
                        ))}
                    </div>
                );
            }, key: "image"
        },
        ...OrderDataColums
        ,
        {
            name: "操作",
            cell: row =>
                <div className="row-actions">
                    <button className="btn btn-action--dark btn-action--sm" onClick={() => { if (row.deliverId) setOrderDeliveryStatus({ ...row, deliveryDate: formatTaiwanDate(row.deliveryDate) }) }} >{row.deliverId ? '運送狀態' : '未指派'}</button >
                    <button className="btn btn-action--primary btn-action--sm" onClick={() => setEditOrder({ ...row, deliveryDate: formatTaiwanDate(row.deliveryDate) })} >編輯</button >
                    <button className="btn btn-action--confirm btn-action--sm" onClick={() => setEditImage(row)} > 上傳圖片</button >
                </div>,
            key: "action"
        }
    ];

    // 控制Datable顯示的colume用
    const [selectedColumns, setSelectedColumns] = useState(
        allColumns
            .map(col => col.key)
            .filter(key => /*key !== "addressDistrict" &&*/ key !== "check") // 預設不勾選 區、check
    );
    const toggleColumn = key => setSelectedColumns(prev => prev.includes(key) ? prev.filter(k => k !== key) : [...prev, key]);
    const columnsToShow = allColumns.filter(col => selectedColumns.includes(col.key));

    const filteredItems = ordersData;

    // 編輯訂單
    const handleSave = async (updatedOrder) => {
        console.log(updatedOrder);
        const response = await updateOrder(updatedOrder);

        if (response.status === 200 && response.data.status === 1) {
            Message(response.data.message);
            console.log(response.status);
            setOrdersData(prev => prev.map(o => o.id === updatedOrder.id ? response.data.result : o));
            setEditOrder(null);
        } else {
            Message(response.data.message, 'warning');
        }
    };

    // 編輯圖片
    const handleImageSave = async (files, type, orderId) => {
        if (files.length <= 0) {
            Message('請選擇圖片', 'warning');
            return;
        }
        if (files.length > 25) {
            Message('已超過最高上限25張圖片', 'warning');
            return;
        }
        console.log(files, type, orderId);

        const formData = new FormData();

        formData.append("orderId", orderId);
        files.forEach(file => formData.append('files', file));
        const response = await uploadOrderImage(formData, type);

        if (response.status === 200 && response.data.status === 1) {
            Message(response.data.message);
            console.log(response.status);
            setEditImage(null);
            await delay(1);
            window.location.reload();
        } else {
            Message(response.data.message, 'warning');
        }
    };

    // 新增訂單
    const handleAddOrder = async (newOrder) => {
        console.log(newOrder)
        const response = await createOrder(newOrder);
        if (response.status === 200 && response.data.status === 1) {
            Message(response.data.message);
            console.log(response.status);
            setIsCreateOpen(false);
            setOrdersData((prev) => [...prev, response.data.result]);
        } else {
            Message(response.data.message, 'warning');
        }

    };

    // 下載Excel
    const handleExcelDownload = async () => {
        try {
            const params = {
                ...searchFields
            };
            const response = await getOrders(params);
            if (response.status === 200) {
                Message(response.data.message, 'success');

                const isCheckColumnVisible = selectedColumns.includes("check");
                let rowsToExport = response.data.result;

                // 如果勾選列可見且有勾選的行，則只導出勾選的行
                if (isCheckColumnVisible && selectedRows.length > 0) {
                    rowsToExport = rowsToExport.filter(item => selectedRows.includes(item.id));
                }

                // 導出欄位排除 "check" 和 "action"
                let columnsToExport = selectedColumns.length > 0
                    ? selectedColumns.filter(key => key !== "check" && key !== "action")
                    : allColumns.map(col => col.key).filter(key => key !== "check" && key !== "action");

                exportData(rowsToExport, columnsToExport);
            }
        } catch (error) {
            Message('搜尋失敗: ' + error.message, 'error');
        } finally {
            setLoading(false);
        }

    }

    const handleSearch = async ({ page = 1, limit = 10, customParams = null }) => {
        console.log(123)

        setLoading(true);
        try {
            const params = {
                page: page,
                limit: limit,
                ...(customParams || searchFields)
            };
            console.log(params);
            const response = await getOrders(params);
            if (response.status === 200) {
                setOrdersData(response.data.result || []);
                setOrderCount(response.data.count || 0);
                Message(response.data.message, 'success');
            }
        } catch (error) {
            Message('搜尋失敗: ' + error.message, 'error');
        } finally {
            setLoading(false);
        }
    }

    const handleBestRouterClick = async () => {
        setLoading(true);
        const isCheckColumnVisible = selectedColumns.includes("check");
        const rowsToUse = isCheckColumnVisible
            ? filteredItems.filter(item => selectedRows.includes(item.id)) // 手動勾選
            : [];

        if (rowsToUse.length <= 0) {
            Message('請規劃一條以上的地址路徑', 'warning');
            setLoading(false);
            return;
        }
        try {
            const res = await getOptimizeRoute(rowsToUse);
            if (res.status === 200) {
                console.log(res.data);
                window.open(res.data.mapsUrl, "_blank");
            }
            else Message(res.status + (res.data.message ?? ''), 'error');
        } catch (error) {
            // Message('產生最佳路線失敗: ' + error.message, 'error');
            return;
        } finally {
            setLoading(false);
        }
    }

    return (
        <>
            {/* 訂單編輯 */}
            <GenericModal
                isOpen={!!editOrder}>
                <EditOrderModal
                    order={editOrder}
                    onClose={() => { setEditOrder(null); }}
                    onSave={handleSave}
                    onChange={setEditOrder}
                />
            </GenericModal>

            {/* 圖片上傳 */}
            <GenericModal
                isOpen={!!editImage}
                onClose={() => { setEditImage(null) }}
            >
                <UploadOrderImageModal
                    order={editImage}
                    onClose={() => { setEditImage(null); }}
                    onSave={handleImageSave}
                />
            </GenericModal>

            {/* 運送狀態查看視窗 */}
            <GenericModal
                isOpen={orderDeliveryStatus}
            >
                <StatusWindow
                    order={orderDeliveryStatus}
                    onClose={(e) => { setOrderDeliveryStatus(null); e.preventDefault(); }}
                />
            </GenericModal>

            {/* 創建訂單 */}
            <GenericModal isOpen={isCreateOpen}>
                <CreateOrder
                    onSubmit={handleAddOrder}
                    onCancel={(e) => { setIsCreateOpen(false); e.preventDefault(); }}
                />
            </GenericModal>

            <div className="orderSheet container-fluid">
                <h1 className="h3 mb-4 mt-4 text-gray-800 text-primary">訂單管理</h1>
                <div className="card shadow mb-4">
                    <div className="card-header d-flex flex-column flex-md-row justify-content-md-between align-items-md-center gap-2 gap-md-0">
                        <div className="d-flex align-items-center gap-2">
                            <h6 className="m-0 fw-bold text-primary">
                                <i className="fas fa-table me-2"></i>訂單總覽
                            </h6>
                        </div>
                        <div className="sheet-actions">
                            <button
                                onClick={() => setIsCreateOpen(true)}
                                className="btn btn-action--confirm btn-action--sm"
                            >
                                <i className="fas fa-plus me-2 "></i>新增訂單
                            </button>
                        </div>
                    </div>
                    {/* 欄位篩選面板 */}
                    <div className="column-selector-header border-top sheet-toolbar">
                        <div className="d-flex gap-2">
                            <button
                                onClick={() => setShowColumnSelector(!showColumnSelector)}
                                className="btn btn-action--primary btn-action--soft btn-action--sm"
                                title="篩選欄位"
                            >
                                <FontAwesomeIcon icon={showColumnSelector ? faChevronUp : faChevronDown} className="me-2" />
                                {showColumnSelector ? '隱藏欄位篩選' : '顯示欄位篩選'}
                            </button>
                            <button
                                onClick={() => setShowSearchArea(!showSearchArea)}
                                className="btn btn-action--neutral btn-action--soft btn-action--sm"
                                title={showSearchArea ? "隱藏搜尋" : "顯示搜尋"}
                            >
                                <FontAwesomeIcon icon={showSearchArea ? faChevronUp : faChevronDown} className="me-2" />
                                {showSearchArea ? '隱藏搜尋' : '顯示搜尋'}
                            </button>
                        </div>
                        {/* 輔助操作區 - 匯出 & 路線規劃 */}
                        <div className="d-flex gap-2">
                            <button
                                className="btn btn-action--primary btn-action--soft"
                                onClick={handleExcelDownload}
                            >
                                <i className="fas fa-download me-2"></i>匯出 Excel 資料
                            </button>
                            <button
                                className="btn btn-action--confirm btn-action--soft"
                                disabled={loading}
                                onClick={handleBestRouterClick}
                            >
                                <i className="fas fa-route me-2"></i>{loading ? '規劃中...' : '產生最佳路線'}
                            </button>
                        </div>
                    </div>
                    {/* 搜尋區域 */}
                    {showSearchArea && (
                        <SearchArea
                            searchForm={searchForm}
                            setSearchForm={setSearchForm}
                            loading={loading}
                            onSearch={handleSearch}
                            onReset={() => {
                                setSearchForm({
                                    id: '',
                                    name: '',
                                    phone: '',
                                    email: '',
                                    deliverName: '',
                                    addressCity: '',
                                    deliveryDateStart: '',
                                    deliveryDateEnd: '',
                                    ids: '',
                                    isShipped: '',
                                    status: '',
                                });
                                setOrdersData([]);
                            }}
                        />
                    )}
                    {showColumnSelector && (
                        <div className="column-selector-panel mb-3">
                            <div className="d-flex justify-content-between align-items-center mb-3">
                                <h6 className="mb-0 fw-bold">選擇要顯示的欄位</h6>
                                <button
                                    className="btn btn-action--neutral btn-action--soft btn-action--sm"
                                    onClick={() => setShowColumnSelector(false)}
                                >
                                    <i className="fas fa-times"></i>
                                </button>
                            </div>
                            <div className="column-selector-grid">
                                {allColumns.map(col => (
                                    <div key={col.key} className="form-check">
                                        <input
                                            className="form-check-input"
                                            type="checkbox"
                                            id={`col-${col.key}`}
                                            checked={selectedColumns.includes(col.key)}
                                            onChange={() => toggleColumn(col.key)}
                                            disabled={col.key === "action"} // 動作欄固定顯示
                                        />
                                        <label className="form-check-label" htmlFor={`col-${col.key}`}>
                                            {col.name}
                                        </label>
                                    </div>
                                ))}
                            </div>
                        </div>
                    )}

                    <div className="orderSheetData card-body">
                        {/* 要加上offset的模式，讓翻頁紐使用的api */}
                        <DataTable
                            columns={columnsToShow}
                            data={filteredItems}
                            pagination
                            highlightOnHover
                            striped
                            responsive
                            noDataComponent="無此訂單資訊"
                            paginationComponentOptions={{
                                rowsPerPageText: '每頁筆數',
                                rangeSeparatorText: '總共',
                            }}
                            defaultSort={{ key: "id", direction: "desc" }}
                            paginationMode={{
                                api: getOrders,
                                count: orderCount,
                                searchFields: searchFields
                            }}
                        />
                    </div>
                </div>
            </div>
            {imageModal.open && (
                <ImageModal
                    image={imageModal}
                    closeImage={closeImage} />
            )}
            <Tooltip id="email-tooltip" />
        </>
    );
};

export { OrderSheet };
